//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'errorDialog',
  data () {
    return {
      errorData: null
    }
  },
  methods: {
    closed () {

    },
    initData (data) {
      let response = data.response
      this.errorData = {
        method: response.config.method,
        url: response.request.responseURL,
        headers: response.config.headers,
        postData: response.config.data,
        response: response.response.data
      }
    },

    sendEmail () {
      // 发送邮件 errorData 待开发-----------------
      // console.log(this.errorData)
      this.sendSuccessHandler()
    },

    sendSuccessHandler () {
      this.$message({
        type: 'success',
        message: '问题已提交给管理员，感谢您的反馈！'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/errorDialog.vue